import { z } from 'zod';
import { Notification } from './notifications.js';
import { WorkItemSummary } from './work.js';
export const MyWork = z.object({
    greetingName: z.string(),
    today: z.string(),
    stats: z.object({
        dueThisWeek: z.number().int(),
        overdue: z.number().int(),
        mentions: z.number().int(),
        unreadMentions: z.number().int(),
        supportInQueue: z.number().int(),
        slaAtRisk: z.number().int(),
        hoursThisWeek: z.number(),
        capacityHours: z.number(),
    }),
    tasks: z.object({
        overdue: z.array(WorkItemSummary),
        today: z.array(WorkItemSummary),
        thisWeek: z.array(WorkItemSummary),
    }),
    /** Where you are needed: unread mentions and replies to your messages. */
    mentions: z.array(Notification),
    supportQueue: z.array(WorkItemSummary),
    /** Null when Chapi is off for the workspace or the person, or nothing to say. */
    chapiSummary: z.object({ text: z.string(), actions: z.array(z.object({ label: z.string(), kind: z.enum(['draft_reply', 'plan_day']) })) }).nullable(),
});
//# sourceMappingURL=mywork.js.map